const email = ['info', 'nuvolem.com'].join('@');

function ContactPage() {
  return (
    <div className="page">
      <h1 className="page-title">Contact</h1>

      <div className="page-map">
        <iframe
          title="Nuvolem location — Greater Seattle Area"
          src="https://maps.google.com/maps?q=Seattle,WA&z=10&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <div className="info-list">
        <div className="info-row">
          <span className="info-label">Location</span>
          <span>Greater Seattle Area</span>
        </div>
        <div className="info-row">
          <span className="info-label">Email</span>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
